import type { Routes } from '@angular/router';

import { ErrorSection } from '../../core/localization/locales';
import { CommonSection } from '../../core/localization/locales/common';
import { ProductErrorsSection } from '../../core/localization/locales/product';
import { prefetchLocalesResolve } from '../../core/localization/prefetch-locales.resolve';

export const routes: Routes = [
	{
		path: ':id',
		resolve: [prefetchLocalesResolve],
		data: {
			prefetchLocales: [CommonSection, ProductErrorsSection, ErrorSection],
		},
		children: [
			{
				path: '',
				pathMatch: 'full',
				loadComponent: () => import('./product.component').then((m) => m.ProductComponent),
			},
		],
	},
];
